import { BaseSingletonService, Singleton } from './service.base';
import { PaymentService } from '~/services/service.payment';
import { AccountService } from '~/services/service.account';
import { AddCreditCardService } from '~/services/service.add.credit.card';
import { AuthService } from '~/services/service.auth';
import { PromotionsService } from '~/services/service.promotions';
import { CodeVerificationService } from '~/services/service.code.verification';
import { PaysafeFormService } from '~/services/service.paysafe.form';

@Singleton()
export class WrapperService extends BaseSingletonService {
    constructor(
        public paymentService: PaymentService,
        public accountService: AccountService,
        public addCreditCardService: AddCreditCardService,
        public authService: AuthService,
        public promotionsService: PromotionsService,
        public codeVerificationService: CodeVerificationService,
        public paysafeFormService: PaysafeFormService,
    ) {
        super();
    }
}
